/*
XXX_JSREFACTOR_XXX
todo @JSREFACTOR
    create e2e test for:
    - if the region alert is visible and there is no cookie set
    - if the region alert is NOT visible when there is ?rac=true in the url
    - if the cookie is set when the modal is closed
*/
import { CookieMonster } from 'root/utils/cookies/cookieMonster';
import { CORS } from 'root/utils/cors/cors';
import { getParamValueFromUrl } from 'root/utils/URLParams/URLParams';
import { gtm } from 'root/utils/tracking/googleTagManagerDeprecated';
import { LoggingHandler } from 'root/utils/errorReporting/LoggingHandler';
import { debounce } from 'lodash';

function regionAlertSpecs() {
    function getCookieName() {
        return '_ls_regionAlert';
    }
    function getCookieValue() {
        return true;
    }
    function getCookieExpirationDate() {
        return 182;
    }
    return {
        getCookieName,
        getCookieValue,
        getCookieExpirationDate,
    };
}

function createRegionAlert() {
    actionBasedOnCookie().setCookieOnRegionSelection();
    actionBasedOnCookie().createRegionAlertBasedOnCookie();
}

function actionBasedOnCookie() {
    const cm = new CookieMonster();
    const cookieName = regionAlertSpecs().getCookieName();
    const cookieValue = cm.getCookie(cookieName);
    const isCookieSet = cookieValue === true;
    const setCookie = () => {
        window.registerCookieComplianceCallback({
            callback: () => {
                return (
                    !isCookieSet &&
                    cm.setCookie(
                        cookieName,
                        regionAlertSpecs().getCookieValue(),
                        regionAlertSpecs().getCookieExpirationDate()
                    )
                );
            },
            isCallOptanonWrapper: true,
        });
    };
    const homepagePaths = ['/', '/ch/', '/ch-de/'];
    const isHome = homepagePaths.includes(window.location.pathname);
    const allowedLoginSlugVariationArray = [
        'login',
        'connexion',
        'ch/login',
        'ch-de/login',
    ];
    const insertSlugSlashes = slug => slug.replace(slug, `/${slug}/`);

    const isLogin = allowedLoginSlugVariationArray.some(
        slug => insertSlugSlashes(slug) === window.location.pathname
    );

    const isAllowedURL = isHome || isLogin;

    const setCookieOnRegionSelection = () => {
        if (getParamValueFromUrl('rac')) setCookie();
    };
    const createRegionAlertBasedOnCookie = () =>
        !isAllowedURL || isCookieSet
            ? null
            : CORS.xdr(
                  '/rest/info/region-alert',
                  'POST',
                  '',
                  successCallback,
                  errorCallback
              );

    return {
        setCookieOnRegionSelection,
        createRegionAlertBasedOnCookie,
        setCookie,
    };
}
function successCallback(data) {
    if (typeof data !== 'string' && data.length === 0) {
        return null;
    }
    createAlertMarkup(data);
    const regionAlert = document.querySelector('.js--regionalert');
    if (regionAlert) {
        const regionAlertModal = new RegionAlert(
            regionAlert,
            actionBasedOnCookie,
            window.location.href
        );
        regionAlertModal.init();
    }
}
function errorCallback(err) {
    LoggingHandler().logError(err, {
        searchTerm: 'region-alert-post-request-error',
        fileName: 'regionAlert.js',
    });
}
function createAlertMarkup(data) {
    const d = document.createElement('div');
    d.innerHTML = data;
    document.body.insertBefore(d, document.body.firstChild);
}
function RegionAlert(alertModal, cookie, location) {
    this.alertModal = alertModal;
    this.cookie = cookie;
    this.cookieName = regionAlertSpecs().getCookieName();
    this.location = location;
    this.openRegionClass = 'js--open-regions';
    this.modalFlipText = alertModal.querySelector('.js--regionAlert-flipText');
    this.modalFlipLink = alertModal.querySelector('.js--regionAlert-flipLink');
    this.modalClose = alertModal.querySelector('.js--regionAlert-close');
    this.modalOverlay = alertModal.querySelector('.modal-region__overlay');
    this.boxInitialHeight = alertModal.querySelector('.modal-region__box').clientHeight;
    this.boxContainer = alertModal.querySelector('.modal-region__box-container');
    this.boxContainerInitialHeight = this.boxContainer.clientHeight;
    this.boxRegions = alertModal.querySelector('.modal-region__box-regions');
    this.boxRecommend = alertModal.querySelector('.modal-region__box-recommend');
    this.boxRecommendInitialHeight = this.boxRecommend.clientHeight;
    this.originalHeight = this.boxInitialHeight - this.boxContainerInitialHeight;
    this.containerDifference =
        this.boxContainerInitialHeight - this.boxRecommendInitialHeight;
    this.body = document.body;
}
RegionAlert.prototype = {
    isScrolledToBottom(el) {
        return el.offsetHeight + el.scrollTop >= el.scrollHeight;
    },

    getBoxHeightBasedOnScreenSize(el) {
        el.style.top = `${this.boxContainer.scrollTop}px`; //in case the container has been scrolled and the user went back to the boxRecommend screen
        if (el.scrollHeight + this.originalHeight > window.innerHeight) {
            this.boxContainer.classList.add('js-scrollOn');
            return {
                height: '50vh',
                overflowY: 'scroll',
            };
        }
        return {
            height: `${el.clientHeight + this.containerDifference}px`,
            overflowY: 'inherit',
        };
    },

    setHeightContainer(elHeight = {}) {
        return Object.assign(this.boxContainer.style, elHeight);
    },

    setScrollOnGraphic(e) {
        if (this.isScrolledToBottom(e.target)) {
            e.target.classList.remove('js-scrollOn');
        } else {
            if (!e.target.classList.contains('js-scrollOn')) {
                e.target.classList.add('js-scrollOn');
            }
        }
    },

    unblockBody() {
        if (this.body.style.position === 'fixed') this.body.style.position = 'relative';
    },

    otherRegionsOpen() {
        this.alertModal.classList.add(this.openRegionClass);
        this.setHeightContainer(this.getBoxHeightBasedOnScreenSize(this.boxRegions));
        this.boxContainer.addEventListener(
            'scroll',
            debounce(this.setScrollOnGraphic.bind(this), 5)
        );
        this.boxContainer.addEventListener('touchmove', () => {
            if (this.body.style.position !== 'fixed') this.body.style.position = 'fixed';
        }); // hack for iphone to block body scrolling while scrolling the boxContainer
        this.modalFlipText.innerHTML = 'Go';
        this.modalFlipLink.innerHTML = 'back';
        this.boxRegions.style.visibility = 'visible';
    },

    otherRegionsClose() {
        this.alertModal.classList.remove(this.openRegionClass);
        this.setHeightContainer(this.getBoxHeightBasedOnScreenSize(this.boxRecommend));
        this.unblockBody();
        this.modalFlipText.innerHTML = 'Not your region? Please take a look at our';
        this.modalFlipLink.innerHTML = 'other regions';
        this.boxRegions.style.visibility = 'hidden';
    },

    otherRegionsToggle() {
        if (this.alertModal.classList.contains(this.openRegionClass)) {
            this.otherRegionsClose();
        } else {
            this.otherRegionsOpen();
        }
    },

    otherRegionsListener() {
        if (this.modalFlipText && this.modalFlipLink !== undefined) {
            this.modalFlipLink.addEventListener(
                'click',
                function () {
                    this.otherRegionsToggle();
                }.bind(this)
            );
        }
    },

    closeModal() {
        const modal = this.alertModal;
        modal.classList.add('modal-region--close');
        this.unblockBody();
        this.cookie().setCookie();
        setTimeout(function () {
            if (modal.parentNode) {
                modal.parentNode.removeChild(modal);
            }
        }, 360);
        gtm.regionAlert('').sendEvent('exit');
    },

    closeListener() {
        if (this.modalOverlay && this.modalOverlay !== undefined) {
            gtm.regionAlert('').sendEvent('shown');
            this.modalOverlay.addEventListener(
                'click',
                function () {
                    this.closeModal();
                }.bind(this)
            );
        }

        if (this.modalClose && this.modalClose !== undefined) {
            this.modalClose.addEventListener(
                'click',
                function () {
                    this.closeModal();
                }.bind(this)
            );
        }
    },
    flagClickListener() {
        const flags = this.alertModal.querySelectorAll('[data-flag]');

        flags.forEach(flag => {
            flag.addEventListener('click', event => {
                if (event.currentTarget.tagName === 'A') {
                    let flagEventAction = event.currentTarget.dataset.flag;
                    gtm.regionAlert(flagEventAction).sendEvent('changed');
                }
            });
        });
    },
    init() {
        this.otherRegionsListener();
        this.closeListener();
        this.flagClickListener();
    },
};

export { createRegionAlert as default, regionAlertSpecs };
